<template>
<b-form-group>
  <legend><strong>{{title}}</strong></legend>
  <slot></slot>
</b-form-group>
</template>

<script>
export default {
  name: "FormSection",
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
